import { render, staticRenderFns } from "./ChartOrders.vue?vue&type=template&id=13b8c0be&scoped=true"
import script from "./ChartOrders.vue?vue&type=script&lang=js"
export * from "./ChartOrders.vue?vue&type=script&lang=js"
import style0 from "./ChartOrders.vue?vue&type=style&index=0&id=13b8c0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8c0be",
  null
  
)

export default component.exports